import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "lan" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.repo.name), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "dot",
        style: _normalizeStyle({ backgroundColor: _ctx.colors[_ctx.repo.language] })
      }, null, 4),
      _createTextVNode(" " + _toDisplayString(_ctx.repo.language), 1)
    ])
  ]))
}